// 透過 post message API 傳遞的事件名稱
export const HEIGHT_RESIZE = '@feverevent/height-resize'; // 通知 zine 的 iframe 高度變更，需要隨著 promo 高度調整 iframe 高度
export const SCROLL_INTO_VIEW = '@feverevent/scroll-into-view';
export const PARENT_REDIRECT = '@feverevent/parent-redirect';
export const PARENT_POPUP = '@feverevent/open-popup';
export const IS_ZINES_EMBEDDED = '@feverevent/is-zines-embedded';
export const IS_WIDGET_EMBEDDED = '@feverevent/is-widget-embedded';
